import { ReactComponent as Logo } from '../../assets/icons/tethering.svg'

const Tethering = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Tethering
